import React from 'react';
import { DARK_THEME } from '../../lib/theme.js';

export function TermsPage() {
  const theme = DARK_THEME;

  return (
    <div style={{
      minHeight: '100vh',
      background: theme.bg,
      color: theme.text,
      fontFamily: 'system-ui, -apple-system, "Segoe UI", sans-serif',
    }}>
      <SimpleHeader theme={theme} />

      <article style={{
        maxWidth: 760,
        margin: '0 auto',
        padding: '40px 20px 80px',
        lineHeight: 1.65,
        fontSize: 15,
      }}>
        <h1 style={{ fontSize: 32, fontWeight: 800, letterSpacing: -1, margin: 0 }}>Handelsbetingelser</h1>
        <p style={{ color: theme.textMuted, fontSize: 13, margin: '8px 0 32px' }}>
          Sidst opdateret: 8. maj 2026
        </p>

        <Section title="1. Generelle oplysninger">
          <p>Disse handelsbetingelser gælder for brug af Tag Team-appen og hjemmesiden gettagteam.com.</p>
          <p>
            Tag Team udbydes af:<br />
            <strong>Anka Media</strong><br />
            Varde, Danmark<br />
            E-mail: hej@gettagteam.com
          </p>
        </Section>

        <Section title="2. Aftalens indgåelse">
          <p>
            Aftalen mellem dig og Anka Media om brug af Tag Team indgås når du opretter en konto i appen
            eller tilmelder dig som beta-bruger. Ved at oprette en konto accepterer du disse handelsbetingelser
            og vores privatlivspolitik.
          </p>
          <p>
            For at oprette en konto skal du være fyldt 16 år. Personer under 16 år må kun bruge tjenesten med
            samtykke fra en forælder eller værge.
          </p>
        </Section>

        <Section title="3. Beskrivelse af tjenesten">
          <p>
            Tag Team er en todo- og opgavehåndteringsapp designet til par. Tjenesten tilbyder funktioner
            såsom:
          </p>
          <ul>
            <li>Oprettelse og deling af opgaver mellem partnere</li>
            <li>Fælles indkøbsliste i realtid</li>
            <li>Kalender-overblik og recurring opgaver</li>
            <li>Statistikker, kærlighedspoint og milepæle</li>
            <li>Notifikationer og påmindelser</li>
          </ul>
          <p>
            Tjenesten leveres "som den er" og udvikles løbende. Funktioner kan tilføjes, ændres eller
            fjernes uden forudgående varsel.
          </p>
        </Section>

        <Section title="4. Brugerkonto og sikkerhed">
          <p>
            Du er ansvarlig for at opretholde fortroligheden omkring din konto. Hvis du logger ind via
            Google eller Facebook, gælder disse tjenesters egne sikkerhedspolitikker.
          </p>
          <p>
            Du må ikke dele din konto med andre eller give andre adgang til at logge ind på din vegne.
            Du er ansvarlig for al aktivitet der foregår under din konto.
          </p>
          <p>
            Hvis du har mistanke om uautoriseret brug af din konto, skal du straks kontakte os på
            hej@gettagteam.com.
          </p>
        </Section>

        <Section title="5. Brugerens forpligtelser">
          <p>Ved brug af Tag Team forpligter du dig til at:</p>
          <ul>
            <li>Bruge tjenesten i overensstemmelse med gældende lov</li>
            <li>Ikke uploade indhold der er ulovligt, krænkende, truende, hadefuldt eller chikanerende</li>
            <li>Ikke forsøge at omgå tekniske sikkerhedsforanstaltninger</li>
            <li>Ikke bruge tjenesten til kommercielle formål uden vores skriftlige tilladelse</li>
            <li>Ikke bruge automatiserede systemer (bots, scrapers) til at tilgå tjenesten</li>
          </ul>
          <p>
            Brud på disse forpligtelser kan medføre øjeblikkelig opsigelse af din konto uden refusion.
          </p>
        </Section>

        <Section title="6. Indhold du opretter">
          <p>
            Du beholder ejendomsretten til alt indhold du opretter i Tag Team (opgaver, beskeder, fotos osv.).
            Ved at bruge tjenesten giver du os en begrænset, ikke-eksklusiv ret til at lagre, vise og
            transmittere dit indhold med det formål at levere tjenesten til dig og din partner.
          </p>
          <p>
            Du er selv ansvarlig for det indhold du opretter. Vi gennemgår ikke aktivt brugerindhold,
            men forbeholder os retten til at fjerne indhold der overtræder disse betingelser eller
            gældende lov.
          </p>
        </Section>

        <Section title="7. Beta-versionen">
          <p>
            Tag Team er i øjeblikket i beta-fase. Det betyder:
          </p>
          <ul>
            <li>Tjenesten kan indeholde fejl og være ustabil</li>
            <li>Funktioner kan ændres eller forsvinde uden varsel</li>
            <li>Data kan i sjældne tilfælde gå tabt — vi anbefaler ikke at bruge appen til kritiske data</li>
            <li>Tjenesten kan i perioder være utilgængelig</li>
          </ul>
          <p>
            Beta-versionen er gratis at bruge. Når Tag Team forlader beta, vil du få besked og mulighed for
            at fortsætte med en gratis version (med reklamer) eller en betalt Premium-version.
          </p>
        </Section>

        <Section title="8. Premium-abonnement (kommer senere)">
          <p>
            Når Tag Team forlader beta, vil vi introducere et Premium-abonnement. Detaljer om pris og
            funktioner annonceres separat. Denne sektion opdateres når Premium lanceres.
          </p>
          <p>
            For abonnementer vil følgende gælde:
          </p>
          <ul>
            <li>Abonnementet fornyes automatisk medmindre du opsiger det</li>
            <li>Du kan opsige til enhver tid og fortsat bruge Premium til abonnementsperioden udløber</li>
            <li>14 dages fortrydelsesret gælder for nye abonnementer i overensstemmelse med dansk lov</li>
            <li>Allerede leverede digitale tjenester kan undtages fra fortrydelsesretten hvis du har givet udtrykkeligt samtykke</li>
          </ul>
        </Section>

        <Section title="9. Reklamer">
          <p>
            Den gratis version af Tag Team kan vise reklamer. For detaljer om hvilke data der deles med
            reklamenetværk, se vores <a href="/privatlivspolitik" style={linkStyle(theme)}>privatlivspolitik</a>.
          </p>
        </Section>

        <Section title="10. Ophør af aftalen">
          <p>Du kan til enhver tid slette din konto i appen under Indstillinger.</p>
          <p>
            Vi kan opsige eller suspendere din konto hvis:
          </p>
          <ul>
            <li>Du overtræder disse handelsbetingelser</li>
            <li>Din konto har været inaktiv i 24 måneder eller mere</li>
            <li>Tjenesten lukker (i så fald får du minimum 30 dages varsel)</li>
          </ul>
          <p>
            Når din konto slettes, fjernes dine data permanent inden for 30 dage. Visse data kan dog
            opbevares længere hvis loven kræver det (f.eks. faktureringsoplysninger ved tidligere køb).
          </p>
        </Section>

        <Section title="11. Ansvarsfraskrivelse">
          <p>
            Tag Team leveres "som den er" uden garantier af nogen art. I det omfang loven tillader det,
            fraskriver vi os ansvar for:
          </p>
          <ul>
            <li>Tab af data eller indhold</li>
            <li>Indirekte eller følgeskader (f.eks. tabt fortjeneste, glemte aftaler eller misforståelser med din partner)</li>
            <li>Afbrydelser eller forsinkelser i tjenesten</li>
            <li>Handlinger eller udsagn fra tredjeparter (herunder din partner i appen)</li>
          </ul>
          <p>
            Vores samlede ansvar over for dig er under alle omstændigheder begrænset til det beløb du
            har betalt for tjenesten i de seneste 12 måneder. For gratis brugere er dette beløb 0 kr.
          </p>
          <p>
            Intet i disse betingelser begrænser vores ansvar for forsætlig eller groft uagtsom skade,
            personskade, eller for ansvar der ikke kan fraskrives efter dansk lov.
          </p>
        </Section>

        <Section title="12. Ændringer">
          <p>
            Vi kan opdatere disse handelsbetingelser fra tid til anden. Ved væsentlige ændringer vil vi:
          </p>
          <ul>
            <li>Underrette dig via e-mail (hvis du har en konto)</li>
            <li>Vise en meddelelse i appen</li>
            <li>Opdatere "Sidst opdateret"-datoen øverst</li>
          </ul>
          <p>
            Hvis du fortsætter med at bruge tjenesten efter ændringerne træder i kraft, anses du for at
            have accepteret de nye betingelser. Hvis du ikke accepterer, kan du slette din konto.
          </p>
        </Section>

        <Section title="13. Lovvalg og værneting">
          <p>
            Disse handelsbetingelser er underlagt dansk ret. Eventuelle tvister skal afgøres ved de
            ordinære danske domstole.
          </p>
          <p>
            Forbrugere kan også indgive klage til <strong>Forbrugerklagenævnet</strong> via{' '}
            <a href="https://www.forbrug.dk" style={linkStyle(theme)} target="_blank" rel="noopener noreferrer">
              forbrug.dk
            </a> eller til EU's online tvistløsningsplatform via{' '}
            <a href="https://ec.europa.eu/consumers/odr" style={linkStyle(theme)} target="_blank" rel="noopener noreferrer">
              ec.europa.eu/consumers/odr
            </a>.
          </p>
        </Section>

        <Section title="14. Kontakt">
          <p>Spørgsmål til disse handelsbetingelser?</p>
          <p>
            📧 <strong>hej@gettagteam.com</strong><br />
            📍 <strong>Anka Media, Varde, Danmark</strong>
          </p>
        </Section>
      </article>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section style={{ marginBottom: 32 }}>
      <h2 style={{ fontSize: 21, fontWeight: 700, letterSpacing: -0.4, margin: '0 0 12px' }}>{title}</h2>
      {children}
    </section>
  );
}

function linkStyle(theme) {
  return {
    color: theme.coral,
    textDecoration: 'underline',
  };
}

function SimpleHeader({ theme }) {
  return (
    <header style={{
      padding: '14px 20px',
      borderBottom: `1px solid ${theme.border}`,
    }}>
      <div style={{
        maxWidth: 760,
        margin: '0 auto',
      }}>
        <a href="/" style={{ display: 'inline-flex', alignItems: 'center', gap: 10, textDecoration: 'none', color: theme.text }}>
          <svg width="28" height="28" viewBox="0 0 120 120">
            <g transform="translate(60,60)">
              <rect x="-30" y="-20" width="20" height="40" rx="3" fill={theme.coral}/>
              <rect x="-36" y="-20" width="32" height="9" rx="3" fill={theme.coral}/>
              <rect x="6" y="-22" width="20" height="40" rx="3" fill={theme.gold}/>
              <rect x="0" y="-22" width="32" height="9" rx="3" fill={theme.gold}/>
            </g>
          </svg>
          <span style={{ fontSize: 16, fontWeight: 700 }}>Tag Team</span>
        </a>
      </div>
    </header>
  );
}
